import { El, Icon } from "@citi-icg-172888/icgds-react";
import React, { useCallback, useEffect, useRef, forwardRef } from "react";
import FooterButtonHoc from "../../common/FooterButtonHoc";
import { useData } from "../../services/context/DataContext";
import { INIT_STEPS } from "../../services/constants/InitialConstants";
import { CONTACT_INFO_INIT } from "../../services/types/LeadRequisitionType";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SubmissionPage = forwardRef((props, ref) => {
  const {
    setIsSubmitted,
    setSteps,
    setCompanyInfo,
    setContactInfo,
    setIsAboutBusiness,
    setIsBasicInfo,
    setBusinessNeedInfo,
    setIsCardOpen,
    setIsCancelClicked,
  } = useData();

  const onCancelHandler = useCallback(() => {
    setIsSubmitted(false);
    setBusinessNeedInfo(() => ({ businessNeeds: [] }));
    setCompanyInfo(null);
    setContactInfo(CONTACT_INFO_INIT);
    setIsAboutBusiness(false);
    setIsBasicInfo(false);
    setSteps(INIT_STEPS);
    setIsCancelClicked(true);
    setIsCardOpen(false);
    // eslint-disable-line react-hooks/exhaustive-deps
    if (typeof window !== 'undefined') {
      const host = window.location.hostname.toLowerCase();

      const DEST: Record<string, string> = {
        'uat.commercialbanking.citidirect.com':
          'https://uat.commercialbanking.citidirect.com/commercial/eppublic/home/',
        'uat.citigroup.com':
          'https://uat.citigroup.com/global/businesses/banking/commercial-bank',
        // add prod if needed:
        'commercialbanking.citidirect.com':
          'https://commercialbanking.citidirect.com/commercial/eppublic/home/',
        'www.citigroup.com':
          'https://www.citigroup.com/global/businesses/banking/commercial-bank',
      };

      const url = DEST[host] ?? DEST['www.citigroup.com']; // fallback
      const tgt = (window.top && window.top !== window.self) ? window.top : window;

      try { (tgt as Window).location.href = url; }
      catch { window.location.href = url; }
    }
    if (window.parent.location.href.includes("contact-us")) window.scrollTo(0, 0);
  }, [setIsSubmitted, setSteps]);

  const firstElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (firstElementRef.current) {
      firstElementRef.current.focus();
      if (window.parent.location.href.includes("contact-us"))
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <El id="submisson_page">
      <Icon type="check-circle" size="lg" style={{ fontSize: "56px", color: "#fff" }} aria-hidden="true" />
      <h4
        className="lmn-h4 lmn-mb-5 lmn-text-headline-0"
        role="text"
        tabIndex={-1}
        aria-label="Request sent"
        ref={firstElementRef}
      >
        Request sent
      </h4>
      <h5
        className="lmn-h5 lmn-mb-4 lmn-text-headline-0"
        role="text"
        aria-label="What happens next?"
      >
        What happens next?
      </h5>
      <El
        className="lmn-mb-9 lmn-text-color-desc"
        role="text"
        aria-label="Thank you for submitting your interest in Citi. We will review your information and get back to you as soon as possible."
      >
        Thank you for submitting your interest in Citi. We will review your information and get back
        to you as soon as possible.
      </El>
      <FooterButtonHoc onSubmit={onCancelHandler} submitText="Close" closeSubmission={true} />
    </El>
  );
});

export default SubmissionPage;
